import { EMediaType } from "@zeal/common/dist/forms";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";

export const postFormRenderJSON = (axios: IAxiosInstance) => {
  return async (
    requestBody: ISchema["#/definitions/TPostFormRenderBodyJSON"]
  ) => {
    const response = await axios.noRetry.request<
      ISchema["#/definitions/TPostFormRenderResponseJSON"]
    >({
      method: "POST",
      url: "/forms/render",
      data: {
        ...requestBody,
        media_type: EMediaType.JSON,
      },
      responseType: "json",
    });
    const resData = response.data;
    if (resData.success) {
      return resData.data;
    }
    throw new Error("Something went wrong");
  };
};
